import { render, staticRenderFns } from "./ContactingBoxContactComms.vue?vue&type=template&id=0804e940&scoped=true&"
import script from "./ContactingBoxContactComms.vue?vue&type=script&lang=js&"
export * from "./ContactingBoxContactComms.vue?vue&type=script&lang=js&"
import style0 from "./ContactingBoxContactComms.vue?vue&type=style&index=0&id=0804e940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804e940",
  null
  
)

export default component.exports